export default function PracticesPage () {
    return (
        <div>
            <p>our practices include farming. more details soon.</p>
        </div>
    )
 }